export default __webpack_public_path__ + "static/media/next-move-en.89af1801.gif";